import { Form, FormRenderProps } from 'react-final-form';
import { useCallback } from 'react';
import { CardActions, Typography } from '@mui/material';

import {
  Button,
  Card,
  CardContent,
  Divider,
  makeZodValidate as makeValidate,
  Page,
} from '@occc-app/design-system';

import { schema } from './segment-create-form.schema';
import { SegmentFormContent } from './components/segment-form-content.component';

import { SegmentFormValues } from '../../segments.types';

const PAGE_TITLE = 'Create Segment';

const validate = makeValidate(schema);

export type SegmentCreatePageProps = {
  onSubmit: (values: SegmentFormValues) => void;
  onCancel: () => void;
};

export const SegmentCreatePage = ({ onSubmit, onCancel }: SegmentCreatePageProps) => {
  const renderForm = useCallback(
    ({ handleSubmit, valid, submitting }: FormRenderProps<SegmentFormValues>) => {
      return (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardContent>
              <Typography variant='h6' component='p' gutterBottom>
                Create Segment
              </Typography>

              <SegmentFormContent />
            </CardContent>

            <Divider />

            <CardActions>
              <Button onClick={onCancel}>Cancel</Button>
              <Button
                variant='contained'
                color='primary'
                type='submit'
                disabled={!valid || submitting}
              >
                Create
              </Button>
            </CardActions>
          </Card>
        </form>
      );
    },
    [onCancel],
  );

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{ title: 'Segment' }}
      containerProps={{ variant: 'md' }}
    >
      <Form<SegmentFormValues> onSubmit={onSubmit} render={renderForm} validate={validate} />
    </Page>
  );
};
